"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClaimsIssuer = void 0;
/* eslint-disable new-cap */
const eciesjs_1 = require("eciesjs");
const crypto_1 = __importDefault(require("crypto"));
const sjcl_1 = require("sjcl");
const jwt_1 = require("@ew-did-registry/jwt");
const claims_1 = require("../claims");
const __1 = require("..");
class ClaimsIssuer extends claims_1.Claims {
    /**
     * Verifies user signature on token and issue new token signed by issuer./
     * Throws if user signature not valid
     *
     * @example
     * ```typescript
     * import { Keys } from '@ew-did-registry/keys';
     * import { ClaimsIssuer } from '@ew-did-registry/claims';
     *
     * const issuer = new Keys();
     * claims = new ClaimsIssuer(issuer);
     * const issuedToken = await claims.issuePublicClaim(token);
     * ```
     * @param { string | IPublicClaim } claim - claim to issue. Can be
     * specified as signed or unsigned claim
     * @returns { Promise<string> } issued token
     */
    issuePublicClaim(claim) {
        return __awaiter(this, void 0, void 0, function* () {
            if (typeof claim === 'string') {
                claim = this.jwt.decode(claim);
            }
            const { claimData, did } = claim;
            const signedToken = yield this.jwt.sign({ claimData, did, signer: this.did }, {
                algorithm: jwt_1.Algorithms.ES256,
                issuer: this.did,
                subject: claim.did,
                noTimestamp: true,
            });
            return signedToken;
        });
    }
    /**
     * Verifies user signature on token, decrypt private data and issue new token
     * with sha256-hashed decrypted data signed by issuer. Throws if user
     * signature not valid
     *
     * @example
     * ```typescript
     * import { Keys } from '@ew-did-registry/keys';
     * import { ClaimsIssuer } from '@ew-did-registry/claims';
     *
     * const issuer = new Keys();
     * claims = new ClaimsIssuer(issuer);
     * const issuedToken = await claims.issuePrivateClaim(token);
     * ```
     * @params { string } token to verify
     * @returns { Promise<string> } issued token
     */
    issuePrivateClaim(token) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.keys.privateKey) {
                throw new Error('Private claim not supported');
            }
            const curve = sjcl_1.ecc.curves.k256;
            const g = curve.G;
            const claim = this.jwt.decode(token);
            const proofVerifier = new __1.ProofVerifier(yield this.document.read(claim.signer));
            if (!(yield proofVerifier.verifyAssertionProof(token))) {
                throw new Error('User signature not valid');
            }
            claim.signer = this.did;
            Object.entries(claim.claimData).forEach(([key, value]) => {
                const decryptedField = (0, eciesjs_1.decrypt)(this.keys.privateKey, Buffer.from(value, 'hex'));
                const fieldHash = crypto_1.default
                    .createHash('sha256')
                    .update(decryptedField)
                    .digest('hex');
                const PK = g.mult(new sjcl_1.bn(fieldHash));
                claim.claimData[key] = PK.toBits();
            });
            delete claim.iss;
            return this.jwt.sign(claim, {
                algorithm: jwt_1.Algorithms.ES256,
                issuer: this.did,
                subject: claim.sub,
                noTimestamp: true,
            });
        });
    }
}
exports.ClaimsIssuer = ClaimsIssuer;
exports.default = ClaimsIssuer;
//# sourceMappingURL=claimsIssuer.js.map